import React, { useState, useEffect } from "react";
import { Menu, X, ChevronDown, Briefcase, Plus } from "lucide-react";

import { Navigate, Link } from "react-router-dom";
import { API_BASE_URL } from "./utils/api";
import NotificationCard from "./components/NotificationCard";
import SystemNotificationService from "./services/SystemNotificationService";
import JobSelectionDropDown from "./components/JobSelectionDropDown";

const Header = ({
  selectedJob,
  onJobChange,
  jobs,
  onMenuItemClick,
  currentView,
  onLogout,
  company,
  user,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPostJobOpen, setIsPostJobOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const menuItems = [
    { id: "dashboard", label: "Dashboard" },
    { id: "assessmentProfile", label: "Assessment Profile" },
    //{ id: "assessmentPreferenceEdit", label: "Assessment Preference" },
    { id: "questionBuilder", label: "Question Builder" },
    { id: "jobseekerList", label: "Jobseekers" },
    { id: "jobseekerBulkUpload", label: "Upload CV / Add jobseeker" },
    { id: "jobseekerserch", label: "Jobseeker Search" },
    { id: "jobListing", label: "Job Listing" },
    { id: "swimLanes", label: "Swim Lanes" },
    //{ id: "interviewSchedule", label: "Interview Schedule" },
    //{ id: "workerManagement", label: "Worker Management" },
    { id: "companysettings", label: "Company Settings" },
  ];

  if (user && user.role === "669e5fdfe2e53b36ad34da8c") { // for admin role only
    menuItems.push({ id: "billing", label: "Billing" });
  }

  const getNotification = async () => {
    const notifications = await SystemNotificationService.get();
    setNotifications(notifications.data);
  };

  useEffect(() => {
    getNotification();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isPostJobOpen && !event.target.closest(".relative")) {
        setIsPostJobOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPostJobOpen]);

  const chageNotificationStatus = async (notificationId) => {
    await SystemNotificationService.delete(notificationId);
    await getNotification();
  };

  return (
    <>
      <header className="flex bg-white text-gray-700 py-4 px-4 md:px-10 border-b border-gray-200 flex justify-between items-center w-full">
        <div className="flex items-center w-1/4">
          <img
            className={`${currentView === "company-settings" && company.logo? 'w-1/2':'w-40'} mr-4 pr-2 cursor-pointer py-5 `}
            src={
              currentView === "company-settings" && company.logo
                ? `${API_BASE_URL}${company.logo?.replace(/^\//, "")}`
                : "/screen-smart-logo.png"
            }
            alt="screensmart"
            onClick={() => onMenuItemClick("dashboard")}
          />
        </div>
        <div className="flex justify-end gap-4 w-3/4 items-center">
          {/* Create Job Button (visible on larger screens)
        <button
          onClick={() => onMenuItemClick("createJob")}
          className="hidden md:flex items-center gap-2 bg-indigo-500 text-white px-4 py-2 rounded-md hover:bg-indigo-600 transition-colors"
        >
          <Plus size={20} />
          Create Job
        </button>

        */}
          {currentView !== "create-job" && (
            <div className="relative hidden lg:block">
              <div className="flex items-center bg-indigo-500 rounded-md hover:bg-indigo-600 transition-colors">
                <Link
                  to="/create-job?mode=create"
                  className="flex items-center gap-2 text-white px-4 py-2 sm:text-sm"
                >
                  <Plus size={20} />
                  Create Job
                </Link>
                <button
                  onClick={() => setIsPostJobOpen(!isPostJobOpen)}
                  className="text-white px-2 py-2 border-l border-indigo-400"
                >
                  <ChevronDown size={16} />
                </button>
              </div>
              {isPostJobOpen && (
                <div className="absolute left-0 right-0 mt-2 bg-white rounded-md shadow-lg py-1 z-50 overflow-visible">
                  <div className="group">
                    <Link
                      to="/create-job"
                      onClick={() => setIsPostJobOpen(false)}
                      className="relative block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      title=""
                    >
                      <span>Post a Job</span>
                      <span className="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 px-3 py-2 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[60]">
                        Action will add a job and will post to the jobboards
                        <span className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-gray-900"></span>
                      </span>
                    </Link>
                  </div>
                  <div className="group">
                    <Link
                      to="/create-job?mode=create"
                      onClick={() => setIsPostJobOpen(false)}
                      className="relative block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      title=""
                    >
                      <span>Create Job</span>
                      <span className="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 px-3 py-2 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[60]">
                        Action will add a job but will not post to jobboards
                        <span className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-r-gray-900"></span>
                      </span>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Job Selection Dropdown */}
          <JobSelectionDropDown
            selectedJob={selectedJob}
            jobs={jobs}
            onJobChange={onJobChange}
            currentView={currentView}
            key="header-job-selection-dropdown"
          />
          {/* Menu Button */}
          <div className="relative">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            {isMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 overflow-visible">
                {menuItems.slice(0, 1).map((item) => (
                  <button
                    key={item.id}
                    onClick={() => {
                      onMenuItemClick(item.id);
                      setIsMenuOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left ${currentView === item.id ? "bg-gray-100" : ""
                      }`}
                  >
                    {item.Icon && (
                      <item.Icon size={16} className="inline-block mr-2" />
                    )}
                    {item.label}
                  </button>
                ))}

                {/* Post a Job and Create Job options */}
                <div className="group">
                  <Link
                    to="/create-job"
                    onClick={() => setIsMenuOpen(false)}
                    className={`relative block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left ${currentView === "create-job" ? "bg-gray-100" : ""}`}
                    title=""
                  >
                    <Plus size={16} className="inline-block mr-2" />
                    <span>Post a Job</span>
                    <span className="absolute right-full top-1/2 transform -translate-y-1/2 mr-2 px-3 py-2 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[60]">
                      Action will add a job and will post to the jobboards
                      <span className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-900"></span>
                    </span>
                  </Link>
                </div>
                <div className="group">
                  <Link
                    to="/create-job?mode=create"
                    onClick={() => setIsMenuOpen(false)}
                    className={`relative block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left ${currentView === "create-job" ? "bg-gray-100" : ""}`}
                    title=""
                  >
                    <Plus size={16} className="inline-block mr-2" />
                    <span>Create Job</span>
                    <span className="absolute right-full top-1/2 transform -translate-y-1/2 mr-2 px-3 py-2 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[60]">
                      Action will add a job but will not post to jobboards
                      <span className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-900"></span>
                    </span>
                  </Link>
                </div>

                {menuItems.slice(1).map((item) => (
                  <button
                    key={item.id}
                    onClick={() => {
                      onMenuItemClick(item.id);
                      setIsMenuOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left ${currentView === item.id ? "bg-gray-100" : ""
                      }`}
                  >
                    {item.Icon && (
                      <item.Icon size={16} className="inline-block mr-2" />
                    )}
                    {item.label}
                  </button>
                ))}
                <div className="border-t border-gray-200 my-1"></div>
                <button
                  onClick={() => {
                    onLogout();
                    setIsMenuOpen(false);
                  }}
                  className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      {notifications.length > 0 ? (
        <div className="p-3 w-full bg-indigo-500 text-center text-white">
          {notifications.map((notification) => (
            <NotificationCard
              notification={notification}
              onClose={chageNotificationStatus}
            />
          ))}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
